<template>
  <hr class="horizontal" style="margin: 8px 0" />
  <div
    class="specific_boost_parent_container"
    :class="[isOpen && 'opened_coupon_container']"
  >
    <div class="specific_booster_container">
      <div class="d-flex-row space-between" @click="openDropdown">
        <div
          class="d-flex-row justify-start flex-5"
          v-if="!checkoutStore.getSelectedBooster"
        >
          <HoodedBoosterPlain />
          <h4 class="font-family-2 bold-l t-white white-space-no">
            {{ $t("cart.specific_booster") }}
          </h4>
        </div>
        <div
          class="d-flex-row justify-start flex-5"
          v-else-if="selectedBooster"
        >
          <img
            :src="handleAvatar(selectedBooster.avatar, publicConfig.apiBaseUrl)"
            alt="Booster avatar"
            height="30"
            width="30"
            style="border-radius: 50%"
          />
          <h4 class="font-family-2 bold-l t-white white-space-no">
            {{ selectedBooster.username }}
          </h4>
        </div>
        <div class="d-flex-row justify-end flex-5">
          <button
            @click.stop="selectBooster(null)"
            type="button"
            v-if="checkoutStore.getSelectedBooster"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.6957 7L17 8.30435L8.30435 17L7 15.6957L15.6957 7Z"
                fill="#9A9A9A"
              />
              <path
                d="M17 15.6957L15.6957 17L7 8.30435L8.30435 7L17 15.6957Z"
                fill="#9A9A9A"
              />
            </svg>
          </button>

          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5333 5.2778L12.5333 7.07279L8 11.1025L3.46667 7.07279L3.46667 5.2778L4.53333 5.2778L4.53333 6.59379L8 9.67531L11.4667 6.59379L11.4667 5.2778L12.5333 5.2778Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>

    <div
      class="booster_list_container hide_scroll cursor-pointer justify-start align-start d-flex-column gap-10"
      v-if="isOpen"
    >
      <div class="d-flex-row justify-start flex-1">
        <input-field
          :variant="'transparent'"
          :size="'small'"
          :icon-start="'SearchOutlinedIcon'"
          placeholder="Search Booster"
          v-model="search"
        />
      </div>
      <div
        class="game_booster flex-1 d-flex-row space-between"
        v-for="booster in filteredBoosters"
        :key="booster"
        role="button"
        @click="
          () => {
            closeDropdown();
            selectBooster(booster.id);
          }
        "
      >
        <div class="d-flex-row booster_select justify-start flex-10">
          <div class="booster_select_online">
            <div class="booster_online" v-if="booster.online === 1" />
            <div class="booster_offline" v-if="booster.online === 0" />

            <img
              :src="handleAvatar(booster.avatar, publicConfig.apiBaseUrl)"
              alt="Booster avatar"
              height="30"
              width="30"
              style="border-radius: 50%"
            />
          </div>
          <div class="d-flex-row space-between">
            <div class="d-flex-column flex-9 justify-start align-start gap-5">
              <p class="t-white font-family-2 bold-l">
                {{ booster.username }}
              </p>
            </div>

            <!-- <label
                            class="t-light font-family-2 regular-s"
                            v-if="
                                booster.online === 0 &&
                                booster?.last_seen_online
                            "
                        >
                            <span class="white-space-no">
                                {{ parseDate(booster?.last_seen_online) }}
                            </span>
                        </label> -->
            <label
              class="t-light font-family-2 regular-s white-space-no current_time_booster"
              v-if="parseDate(booster?.timezone)"
            >
              <ClockIcon />
              {{ parseDate(booster?.timezone) }}
            </label>
          </div>
        </div>
        <RadioButton
          :checked="checkoutStore.getSelectedBooster == booster.id"
        />
      </div>
    </div>
  </div>
  <hr class="horizontal" style="margin-bottom: 8px" />
</template>

<script setup>
import HoodedBoosterPlain from "~/components/icons/HoodedBoosterPlain.vue";
import InputField from "~/components/custom/InputField.vue";
import RadioButton from "~/components/custom/RadioButton.vue";
import ClockIcon from "~/components/icons/ClockIcon.vue";
import { ref, computed } from "vue";
const checkoutStore = useCheckoutStore();
const { currentGameSlug } = useGameComposable();
const { public: publicConfig } = useRuntimeConfig();
const { getAuthHeaders } = useFunctions();
const headers = getAuthHeaders();
const route = useRoute();

const boosters = ref([]);
const search = ref("");
const isOpen = ref(false);

const selectedBooster = computed(() => {
  return boosters.value?.find(
    (booster) => booster.id == checkoutStore.getSelectedBooster
  );
});

const openDropdown = () => {
  isOpen.value = !isOpen.value;
  if (isOpen.value) {
    fetchData();
  }
};

const filteredBoosters = computed(() => {
  return boosters.value.filter((item) =>
    item.username.toLowerCase().includes(search.value.toLowerCase())
  );
});

const closeDropdown = () => {
  isOpen.value = false;
};

function parseDate(timezone) {
  const userTimeZone = timezone;
  if (timezone) {
    const options = {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
    };
    const userTime = new Date().toLocaleString([], options);
    return userTime;
  } else {
    return "";
  }
}
function selectBooster(boosterId) {
  checkoutStore.setBooster(boosterId);
}
const fetchData = async () => {
  try {
    const { data: response, error } = await useApiPost(`/api/get-boosters`, {
      method: "POST",
      credentials: "include",
      body: {
        game: currentGameSlug,
        params: ["online_sort"],
        count: 10000, //default 10
        page: 1, //default 1
      },
      headers: {
        ...headers,
      },
      lazy: true,
    });
    if (response?.boosters) {
      boosters.value = response?.boosters;
    }
  } catch (error) {
    console.log(error);
  }
};

if (route?.query["booster-id"]) {
  fetchData();
}
// fetchData();
// console.log(response.value);
</script>
